
<div class="col-12 mt-2">
  <div class="col-12 flex border border-info rounded " #topDiv>
    <div class="col-6">
      <button pButton icon="fa fa-refresh" label="Refresh" class="w-3 p-2 buttonsRound noHover shadow"
        (click)="getDataForDeliveryPlanning();getFilesFromAzure();"></button>
    </div>
    <div class="col-6 flex justify-content-end">
      <button pButton label="Create Delivery ConfigFile" icon="fa fa-download" class="w-4 p-2 buttonsRound noHover float-right shadow"
        [disabled]="!(batchIDToStartDelivery && batchIDToStartDelivery.length > 0)" (click)="createCofigFile()"></button>
    </div>
   </div>
  <div class="col-12" [style.height.px]="divHeight">
    <p-table #dt [loading]="loading" [value]="batches"  [style]="{'overflow':'visible', 'word-wrap': 'break-word'}" [columns]="scrollableCols"  [loading]="loading" >
      <ng-template pTemplate="caption" style="height: 3rem;">
        <div class="flex justify-content-end" >
            <em class="fa fa-search" style="margin:4px 4px 0 0"></em>
            <input class="p-1" type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
    </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr >
          <th scope="col" *ngFor="let col of columns" class="text-center" style="min-width: 10rem;" >
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-batch let-columns="columns">
        <tr [pSelectableRow]="batch">
          <ng-container *ngFor="let col of columns">
            <td *ngIf="(col.field == 'batchID')" style="width: 10rem;height: 2.6rem;" class="text-center">
              <a [routerLink]="['/covid19entryNew', batch.batchID]"  >{{ batch[col.field] }}</a>
            </td>
            <td *ngIf="(col.field != 'batchID')" style="width: 10rem;height: 2.6rem;" class="text-center" [ngClass] = "getCellColor(col.field, batch)">
              {{ getTextCellValue(col.field, batch) }}
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="19" class="text-center">
            No records found
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="col-5 pl-0 mt-3" *ngIf="listOfFile && listOfFile.length>0">
      <div class="col-12 flex"><h5><u>Delivery ConfigFiles</u></h5></div>
      <div class="col-6 float-left"  *ngFor="let file of listOfFile">
          <a href="javascript:void(0);" (click)="downloadFile(file)"><u>{{file}}</u></a>
      </div>
    </div>
  </div>
</div>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
